import * as React from 'react';
import { GMAPS_API_KEY } from '../../constants/config';
import GoogleMapEmbed from './GoogleMapEmbed';

export class Address {
    address1?: string;
    address2?: string;
    city: string;
    state: string;
}

export class GoogleMapEmbedProps {
    height?: string | number;
    width?: string | number;

    name?: string;
    longtitude?: number;
    latitude?: number;
    address?: Address;
}

/**
 * Google map using iframe (cheaper than dynamic API).
 * Prioritizes lat/lng over address if both passed
 */
export default class GoogleMapEmbedContainer extends React.Component<GoogleMapEmbedProps, {}> {
    static defaultProps: Partial<GoogleMapEmbedProps> = {
        height: 450,
        width: 600,
    };

    private getGeoQuery(latitude: number, longtitude: number) {
        return encodeURIComponent(`${latitude},${longtitude}`);
    }

    private getAddrQuery(address: Address, name?: string) {
        return encodeURIComponent(
            `${name || ''} ${address.address1 || ''}
            ${address.address2 || ''} ${address.city} ${address.state}`
        );
    }

    private getMapSrc(query: string) {
        return `https://www.google.com/maps/embed/v1/place?q=${query}&key=${GMAPS_API_KEY}`;
    }

    render() {
        const { width, height, latitude, longtitude, address, name } = this.props;

        let query;
        if (!!latitude && !!longtitude) {
            query = this.getGeoQuery(latitude, longtitude);
        } else if (!!address) {
            query = this.getAddrQuery(address);
        } else if (!!name) {
            query = name;
        } else {
            query = null;
        }

        return <GoogleMapEmbed query={query ? this.getMapSrc(query) : undefined} width={width} height={height} />;
    }
}
